module.exports = __webpack_public_path__ + "static/media/achievement-tier-1.99823463.svg";